
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';


let campaignJs = {};

// var JSwiper = Swiper;

campaignJs.swiperProduct = () => {

  var opts = {
    modules: [Navigation, Pagination, Lazy],
    preloadImages: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },

    // slidesPerView: 1.65,
    slidesPerView: 1.9,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      980: {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false,
        loop: false,
      }
    },
    observer: true,
    resizeObserver: true,
  }

  var swiper = new Swiper('.js-swiper', opts);
}

document.addEventListener('DOMContentLoaded', () => {
  campaignJs.swiperProduct();
});



// WEBPACK FOOTER //
// ./scripts/components/campaign.js